// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"5537572e","340":"d609aa98","347":"dd754d5a","524":"c06ca6eb","703":"147ec785","777":"addf3308","950":"cda2e5f5"}[chunkId] + ".chunk.js";
};